import React, { useState } from "react";
import { Row, Button, DropdownToggle, DropdownMenu, Dropdown, DropdownItem } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";
import defaultValues from "../../constants/defaultValues";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { addRequestItem } from "../../redux/request/actions";

const RequestHeadSection = ({ request, addRequestItem, history }) => {
  const [dropdownSplitOpen, setDropdownSplitOpen] = useState(false);

  const toggleSplit = () => setDropdownSplitOpen(!dropdownSplitOpen);

  const handleRequestStatus = (status) => addRequestItem({ id: request.id, status });

  const goBack = () => history.goBack();

  const getRequestStatuses = () => {
    const { requestStatusEnum } = defaultValues;
    const otherRequestStatuses = Object.values(requestStatusEnum).filter(
      requestStatus =>
        requestStatus !== requestStatusEnum[request.status]
        && requestStatus !== "request.status_pending"
    );

    const otherRequestStatusIntlKeys = Object.keys(requestStatusEnum).filter(
      requestStatus => requestStatus !== request.status && requestStatus !== "PENDING"
    );

    return otherRequestStatuses.map((reqStatus, index) => (
      <DropdownItem key={`${index}`}
        onClick={() => handleRequestStatus(otherRequestStatusIntlKeys[index])}
      >
        <IntlMessages id={`${reqStatus}`} />
      </DropdownItem >
    ));
  }

  const getColorForRequestStatus = () => {
    const { status } = request;
    if (status === "CLOSED") return "light";
    else if (status === "OPEN") return "primary";
    else if (status === "CANCELED") return "light";
    else return "warning";
  }

  // Burayı satırı hiçbir şekilde silme
  if (!request) return (<>Request Not Found</>);

  return (
    <Row>
      <Colxx xxs="12" lg="3" className="mb-4">
        <Button onClick={goBack} type="button" color="outline-info" size="sm"
          className="btn outline-light flex-grow-1 "
        >
          <i className="iconsminds-arrow-left booking-heading-icon" />
          <IntlMessages id="request.back_button" />
        </Button>
      </Colxx>
      <Colxx xxs="12" lg="6" className="mb-4">
        <h1 className="text-center align-middle w-100">
          <IntlMessages id="request.request_details" />
        </h1>
      </Colxx>
      <Colxx xxs="12" lg="3"
        className="mb-4 top-right-button-container"
        style={{ textAlign: "right" }}
      >
        <Dropdown isOpen={dropdownSplitOpen} toggle={toggleSplit} className="text-center w-100">
          <DropdownToggle caret color={`${getColorForRequestStatus()}`}>
            <IntlMessages id={`${defaultValues.requestStatusEnum[request.status]}`} />
          </DropdownToggle>
          <DropdownMenu>{getRequestStatuses()}</DropdownMenu>
        </Dropdown>
      </Colxx>
    </Row>
  );
};

const mapStateToProps = () => ({});

const mapActionsToProps = {
  addRequestItem,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(RequestHeadSection)
);
